import { Heading } from '@infura/packages.ui/Heading'
import { Text } from '@infura/packages.ui/Text'

import { ArticleItem } from 'components/gettingStartedTour/StepStartBuilding/ArticleItem'
import { ArticleItemsData } from 'components/gettingStartedTour/StepStartBuilding/data'
import SlickGallery from 'components/ui/SlickGallery'

const defaultSettingsGallery = {
  adaptiveHeight: true,
  centerMode: true,
  centerPadding: '30px',
  dots: true,
  infinite: false,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipeToSlide: true
}

const StepStartBuilding = () => {
  return (
    <div className='m-auto w-full max-w-screen-2xl md:overflow-hidden'>
      <Heading as='h4'>Start building</Heading>
      <Text alternative className='mb-4'>
        Explore the Resource Hub below to start building a winning Web3 app in no time.
      </Text>
      <div className='hidden gap-4 md:grid md:grid-cols-2 xl:grid-cols-4'>
        {ArticleItemsData.map((item, i) => (
          <div key={`item-${i}`}>
            <ArticleItem {...item} />
          </div>
        ))}
      </div>
      <div className='-mx-2 pb-6 md:hidden'>
        <SlickGallery
          classes='-mr-6'
          galleryItems={ArticleItemsData.map((item, i) => (
            <div className='h-full p-2' key={`item-${i}`}>
              <ArticleItem {...item} isLimitMaxWidth />
            </div>
          ))}
          settings={{
            ...defaultSettingsGallery,
            arrows: false,
            centerMode: false,
            infinite: false,
            variableWidth: true
          }}
        />
      </div>
    </div>
  )
}

export default StepStartBuilding
